<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Task`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1C5.94772 1 5.5 1.44772 5.5 2V2.33325H2.91683C1.90431 2.33325 1.0835 3.15406 1.0835 4.16658V7.91658C1.0835 7.94468 1.08465 7.9725 1.08693 8H1.08594V16.5C1.08594 17.6046 1.98137 18.5 3.08594 18.5H16.9113C18.0159 18.5 18.9113 17.6046 18.9113 16.5V8.02212C18.915 7.98744 18.9168 7.95223 18.9168 7.91658V4.16658C18.9168 3.15407 18.096 2.33325 17.0835 2.33325H14V2C14 1.44772 13.5523 1 13 1C12.4477 1 12 1.44772 12 2V2.33325H7.5V2C7.5 1.44772 7.05228 1 6.5 1ZM12 5.5V4.33325H7.5V5.5C7.5 6.05228 7.05228 6.5 6.5 6.5C5.94772 6.5 5.5 6.05228 5.5 5.5V4.33325H3.0835V6.91658H16.9168V4.33325H14V5.5C14 6.05228 13.5523 6.5 13 6.5C12.4477 6.5 12 6.05228 12 5.5ZM14.8736 11.1239C15.2641 10.7333 15.2641 10.1002 14.8736 9.70964C14.4831 9.31912 13.8499 9.31912 13.4594 9.70964L9.1665 14.0025L7.37361 12.2096C6.98309 11.8191 6.34992 11.8191 5.9594 12.2096C5.56887 12.6002 5.56887 13.2333 5.9594 13.6239L8.4594 16.1239C8.84992 16.5144 9.48309 16.5144 9.87361 16.1239L14.8736 11.1239Z"/></svg>
</template>
<script>

export default {
  name: 'IconTask',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
